<script setup lang="ts">
import { computed } from 'vue';
import store from '@/store';

const item = computed({
  get: () => store.getters['sticker/GET_STICKER'],
  set: (value) => {
    store.dispatch('sticker/SET_STICKER', value);
  },
});

const updateFaqs = (faqs: any[]) => {
  store.dispatch('sticker/SET_STICKER', { faqs });
};

const onAddFaq = () => {
  const current = item.value.faqs || [];
  const newFaq = {
    id: null,
    question: '',
    answer: '',
    sortOrder: current.length,
  };
  updateFaqs([...current, newFaq]);
};

const onRemoveFaq = (index: number) => {
  const faqs = [...(item.value.faqs || [])];
  faqs.splice(index, 1);
  updateFaqs(faqs);
};

const updateField = (index: number, field: string, value: string) => {
  const faqs = [...(item.value.faqs || [])];
  faqs[index] = { ...faqs[index], [field]: value };
  updateFaqs(faqs);
};
</script>

<template lang="pug">
section.c-tab-faq
  .c-faq-item(v-for="(faq, i) in (item.faqs || [])" :key="i")
    .c-faq-item__header
      .c-faq-item__drag-handle ⠿
      .c-faq-item__badge {{ i + 1 }}
      span.c-faq-item__badge-label FAQ {{ i + 1 }}
      fai.c-faq-item__delete(
        type="fal"
        icon="trash"
        @click="onRemoveFaq(i)"
      )

    .c-faq-item__body
      .c-faq-item__field
        span.c-faq-item__label Question
        input.c-input(
          type="text"
          placeholder="Enter question..."
          :value="faq.question"
          @input="(e) => updateField(i, 'question', e.target.value)"
        )
      .c-faq-item__field
        span.c-faq-item__label Answer
        textarea.c-input.c-input--textarea(
          placeholder="Enter answer..."
          :value="faq.answer"
          @input="(e) => updateField(i, 'answer', e.target.value)"
        )

  .c-faq__add(@click="onAddFaq")
    fai(type="fal" icon="plus-circle").size-16
    span + Add FAQ
</template>

<style scoped lang="scss">
.c-tab-faq {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.c-faq__add {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  border: 1px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  font-family: inherit;
  transition: border-color 0.2s, color 0.2s;

  &:hover {
    border-color: #1ebeaf;
    color: #1ebeaf;
  }
}

.c-faq-item {
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
  }

  &__drag-handle {
    font-size: 18px;
    color: #aaa;
    cursor: grab;
  }

  &__badge {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #f5a623;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: inherit;
    flex-shrink: 0;
  }

  &__badge-label {
    font-size: 15px;
    font-weight: 600;
    font-family: inherit;
    flex: 1;
  }

  &__delete {
    color: #e02020;
    cursor: pointer;
    font-size: 16px;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }

  &__body {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    font-family: inherit;
  }

  .c-input {
    width: 100%;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 0 12px;
    font-size: 14px;
    font-family: inherit;
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;

    &:focus {
      border-color: #1ebeaf;
    }

    &--textarea {
      height: 90px;
      padding: 10px 12px;
      resize: vertical;
    }
  }
}
</style>
